import { URL_MFC_SHARE_FEED } from '../constants/urls'

export type MFCShareStylesheet = 'slider' | 'feed' | 'iframe' | 'profile'

const getShareCssUrl = (stylesheet: MFCShareStylesheet) => {
    if (typeof window === 'undefined') return null
    if (!/\.myfreecams\.com$/.test(window.location?.hostname || '')) return null
    return `${window.location.origin}/static/css/mfc.app.share.${stylesheet}.css`
}

export const getMFCShareIframeQueryParams = (
    darkMode: boolean,
    stylesheet: MFCShareStylesheet,
    hideHeader?: boolean,
) => {
    const params = new URLSearchParams({
        color_scheme_dark: String(darkMode),
        origin: 'app',
        // only render new iframes w /transparent background
        ...(stylesheet === 'slider' || stylesheet === 'feed'
            ? { transparent: 'true' }
            : {}),
        ...(stylesheet === 'feed' ? { target: '_blank' } : {}),
        ...(hideHeader ? { hide_header: 'true' } : {}),
    })
    const cssUrl = getShareCssUrl(stylesheet)
    if (cssUrl) params.set('css_url', cssUrl)
    return params
}

export const getShareFeedUrl = (buttonName: string, modelName?: string) => {
    const params = new URLSearchParams({
        auto_login: 'true',
        utm_source: 'app',
    })
    if (modelName) params.set('utm_term', modelName)
    params.set('utm_content', buttonName)
    return `${URL_MFC_SHARE_FEED}?${params.toString()}`
}
